import {Component, inject} from '@angular/core';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-login',
  template: `
    <div class="hero min-h-screen bg-base-200">
      <div class="hero-content flex-col w-full max-w-sm">

        <!-- Logo -->
        <img
          src="logo.png"
          alt="Prezzemolo & Vitale"
          class="w-64 mb-2"
        />

        <!-- Login Card -->
        <div class="card bg-base-100 w-full shadow-2xl">
          <div class="card-body">
            <h2 class="text-2xl font-light tracking-widest text-center text-base-content/70 uppercase mb-4">Accedi per timbrare</h2>
              <a class="btn btn-primary w-full mt-4" type="button" [href]="loginPath">
                Accedi
              </a>
          </div>
        </div>

      </div>
    </div>
  `,
  styles: ``
})
export class LoginComponent {
  private auth = inject(AuthService);

  get loginPath(): string {
    return this.auth.loginPath;
  }
}
